import { MonoTypeOperatorFunction, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

/** Passes only a tuple with all values defined */
export function filterTruthyValues<T extends unknown[]>(): MonoTypeOperatorFunction<T> {
  return (input$): Observable<T> => input$.pipe(filter((items) => items.every((i) => !!i)));
}
